import { lazy } from '@atlassian/react-loosely-lazy';
import type { EditView } from './index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyEditView = lazy<typeof EditView>(() =>
	import(/* webpackChunkName: "async-jira-issue-field-entitlement-edit" */ './index').then(
		(module) => module.EditView,
	),
);
